import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import type { ReactNode } from 'react';

import { isPublicBatteryRoute } from '@/utils/publicBatteryEcomm/pageUrls';

const PublicBatteryFlagsmithInit = dynamic(
  () => import('./PublicBatteryFlagsmithInit')
);

type PublicBatteryFlagsmithProviderProps = {
  children: ReactNode;
  preventFetch?: boolean;
};

export default function PublicBatteryFlagsmithProvider({
  children,
  preventFetch,
}: PublicBatteryFlagsmithProviderProps) {
  const { pathname } = useRouter();
  const shouldLoadFlagsmith =
    Boolean(preventFetch) || isPublicBatteryRoute(pathname);

  if (!shouldLoadFlagsmith) {
    return children;
  }

  return (
    <PublicBatteryFlagsmithInit preventFetch={preventFetch}>
      {children}
    </PublicBatteryFlagsmithInit>
  );
}
